import { render, staticRenderFns } from "./ViewMethodDissemination.vue?vue&type=template&id=f8843d16"
import script from "./ViewMethodDissemination.vue?vue&type=script&lang=js"
export * from "./ViewMethodDissemination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports